import {useEffect} from "react";
import {Control, Controller} from "react-hook-form";
import {classNames} from "primereact/utils";
import "./TextInputPassword.scss";
import {Password} from "primereact/password";
import {InputText} from "primereact/inputtext";

export interface TextInputProps {
    id: string;
    value: string | number;
    onValueChange: (property: string, value: string) => void;
    labelText: string;
    icon: string;
    iconAlign: string;
    placeholderText: string;
    control: Control;
    setValue?: any;
    errors: any;
    rules?: any;
    disabled?: boolean;
    feedback?: boolean
    onKeyPress?: (e: any) => void;
};

export const TextInputPassword = (p: TextInputProps) => {
    const {
        id,
        value,
        onValueChange,
        labelText,
        icon,
        iconAlign,
        placeholderText,
        control,
        setValue,
        errors,
        rules,
        disabled,
        feedback,
        onKeyPress
    } = p;

    useEffect(() => {
        if (setValue) setValue(labelText, value)
    }, [value]);

    return (
        <div className="text-input-password">
            <label
                className={classNames("text-label", {
                    'p-error': errors[labelText],
                })}
                htmlFor={id}
            >
                {labelText}
            </label>
            <div className={ iconAlign === 'left' ? "p-input-icon-left" : "p-input-icon-right" }>
                <Controller
                    name={labelText}
                    control={control}
                    rules={rules}
                    render={({ field, fieldState }) => (
                        <Password
                            {...field}
                            id={id}
                            value={value}
                            feedback={feedback}
                            onChange={(e)=>{
                                field.onChange(e);
                                onValueChange(id, e.target.value)}}
                            className={classNames("text-input-field", { 'p-invalid': fieldState.invalid })}
                            placeholder={placeholderText}
                            disabled={disabled}
                            onKeyPress={onKeyPress}
                        />
                    )}
                />
                <span className="textinput-icon-wrapper">
                    <i className={icon + " textinput-icon"} />
                </span>
            </div>
        </div>
    );
};


